import {
  Stack,
  type SuggestionsListComponentProps,
  Text,
} from '@iconik-io/uad';

import { FLAG_SIMPLIFIED_ACLS } from '../../../../analytics/flags';
import { growthbook } from '../../../../analytics/growthbook';
import { MentionsListItem } from './mentions_list_item';

import styles from './mentions_list.module.css';

export function MentionsListHeader({ label }: { label: string }) {
  return (
    <Text color="high_emphasis" variant="value">
      {label}
    </Text>
  );
}

export function MentionsList({
  items,
  onItemClick,
  focusedOptionId,
}: SuggestionsListComponentProps) {
  // extract items into groups or users based on id prefix, email prefixes are considered users
  const users =
    items.filter(
      (item) => item.id.startsWith('user_id:') || item.id.startsWith('email:'),
    ) ?? [];
  const groups = items.filter((item) => item.id.startsWith('group_id:')) ?? [];

  return (
    <Stack gap="m" className={styles.mentions_list}>
      {users.length > 0 ? (
        <MentionsListHeader key="header_users" label="Users" />
      ) : null}
      {users.map((item) => (
        <MentionsListItem
          id={item.id}
          key={item.id}
          label={item.label}
          onClick={onItemClick}
          active={focusedOptionId === item.id}
        />
      ))}
      {groups.length > 0 ? (
        <MentionsListHeader
          key="header_groups"
          label={growthbook?.isOn(FLAG_SIMPLIFIED_ACLS) ? 'Teams' : 'Groups'}
        />
      ) : null}
      {groups.map((item) => (
        <MentionsListItem
          id={item.id}
          key={item.id}
          label={item.label}
          onClick={onItemClick}
          active={focusedOptionId === item.id}
        />
      ))}
    </Stack>
  );
}
